import React, { useState, useEffect } from 'react';
import { SECTIONS } from '../config/sections';

const SectionSidebar = () => {
  const [activeId, setActiveId] = useState('home');

  useEffect(() => {
    const triggerOffset = 0.35; // active when section top is in upper 35% of viewport

    const updateActive = () => {
      const viewportHeight = window.innerHeight;
      const trigger = viewportHeight * triggerOffset;

      let current = 'home';
      for (const { id } of SECTIONS) {
        const el = document.getElementById(id);
        if (el) {
          const { top } = el.getBoundingClientRect();
          if (top <= trigger) current = id;
        }
      }
      setActiveId(current);
    };

    updateActive();
    window.addEventListener('scroll', updateActive, { passive: true });
    return () => window.removeEventListener('scroll', updateActive);
  }, []);

  const handleClick = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <aside className="section-sidebar" aria-label="Page sections">
      <div className="section-sidebar-inner">
        {SECTIONS.map(({ id, label, suit }) => {
          const isRed = suit === '♥' || suit === '♦';
          return (
            <button
              key={id}
              type="button"
              className={`section-sidebar-item ${activeId === id ? 'active' : ''}`}
              onClick={() => handleClick(id)}
              aria-current={activeId === id ? 'true' : undefined}
              aria-label={`Go to ${label}`}
            >
              <span className="section-sidebar-label">{label}</span>
              <span className={`section-sidebar-suit ${isRed ? 'red' : ''}`}>{suit}</span>
            </button>
          );
        })}
      </div>
    </aside>
  );
};

export default SectionSidebar;
